<template>
  <div class="pre-req" dir="rtl">
    <div class="">
      <div
        ref="form"
      >
        <div class="page-title">
          {{request_info.RequestName}}
        </div>
        <ul class="relative">
          <!--            *****************************-->
          <!--            <li cols="12" class="pa-1">-->
          <!--              <label>-->
          <!--                درخواست-->
          <!--                :-->
          <!--              </label>-->
          <!--            <span>-->
          <!--               -->
          <!--              </span>-->
          <!--            </li>-->
          <li cols="12" class="">
            <label>{{ $t('lastStatus') }}</label>
            <span>
                {{request_info.LastStatus}}
              </span>
          </li>

          <li cols="12" class="">
            <label>{{ $t('requestNumber') }}</label>
            <span>
                {{request_info.RequestCode}}
              </span>
          </li>

          <li cols="12" class="">
            <label>{{ $t('registerDate') }}</label>
            <span>
                {{request_info.RequestTime}}
              </span>
          </li>

          <li cols="12" class="">
            <label>{{ $t('description') }}</label>
            <span>
                {{request_info.Summary}}
              </span>
          </li>

          <li cols="12" class="relative">
            <label>{{ $t('mobileNo') }}</label>
            <span>
                  {{request_info.CustomerMobile}}
              </span>
            <a :href="'tel:'+request_info.CustomerMobile" class="call-btn">
              <v-icon>
                mdi-phone
              </v-icon>
            </a>
          </li>
          <li cols="12" class="relative" v-if="request_info.OtherPhoneNO != null">
            <label>{{ $t('secoundMobileNo') }}</label>
            <span>
                  {{ request_info.OtherPhoneCode+request_info.OtherPhoneNO}}
              </span>
            <a :href="'tel:'+request_info.OtherPhoneCode+request_info.OtherPhoneNO" class="call-btn">
              <v-icon>
                mdi-phone
              </v-icon>
            </a>
          </li>

          <li cols="12" class="">
            <label>{{ $t('referDescription') }}</label>
            <span>
                {{request_info.StatusSummary}}
              </span>
          </li>
          <hr>
          <li v-if="request_info.EjraiStatusSummary!=null">
            <label>وضعیت های اجرائی</label>

            <div v-for="ejraii in JSON.parse(request_info.EjraiStatusSummary)">
              {{ejraii.StatusName}} : {{ejraii.Summary}}
            </div>

          </li>
        </ul>
        <v-row>
          <v-col cols="12" class="pa-4 pt-1">
            <label>{{ $t('addresses') }}</label>
            <div v-for="item_address in request_info.Addresses">
              <div class="addresses">
                <div>
                  <div class="flex-no-wrap justify-space-between">
                    <div>

                      <p>{{get_request_address(item_address)}}</p>
                      <div v-text="item_address.PhoneCode+item_address.PhoneNO" class="address-phone"></div>
                      <label v-if="item_address.FromTime !=null">{{item_address.FromTime}} -
                        {{item_address.ToTime}}
                      </label>
                      <div class="pt-3 text-center">

                        <v-btn

                          v-if="item_address.Lat !=null"
                          class="ml-2"
                          outlined
                          rounded
                          color="primary"
                          v-on:click="go_direction(item_address)"
                        >{{ $t('navigation') }}</v-btn>
                        <a :href="'tel:'+item_address.PhoneCode+item_address.PhoneNO" class="call-phone">
                          <v-icon>
                            mdi-phone
                          </v-icon>
                        </a>
                      </div>
                    </div>

                  </div>

                </div>

              </div>

            </div>

          </v-col>
        </v-row>
        <v-row>

          <button class="btn start-to-go-btn" v-if="action_button_text != ''" v-on:click="go_to_categories()">
            {{action_button_text}}
          </button>

        </v-row>

        <v-dialog  class="" v-model="dialog_service_out_branch" >
          <v-card class="dialog1-card">
            <div class="text-center dialog-header">
          <span class="name">{{ $t('requestStatus') }}</span>

            </div>
            <v-card-text>
              <v-container>
                <div >
                  {{$t('isRequestInBranchOrNot')}}
                </div>

              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="mr-5 ml-5 btn-info save-btn" text @click="service_out_branch_action(8)">{{ $t('inLocation') }}</v-btn>
              <button class="btn-success save-btn" @click="service_out_branch_action(7)">{{ $t('inBranch') }}</button>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

    </div>
  </div>
</template>
<script>
  import { bus } from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        errors: [],
        request_info: [],
        request_statuses: [],
        action_button_text: '',
        next_action_status: 0,
        dialog_service_out_branch: false,
        technician_name: 'hamid mokhtari',
        device_password: 'hamid mokhtari',


      }
    },
watch: {
      selected_province: function () {
        this.get_cities()
      }
    },
mounted () {
      // var passing_data = JSON.parse(localStorage.getItem('request_data'));
      // this.enable_send_from_country = passing_data.on_site_service;
      // this.get_phone_prefix()
      this.get_request_info()
      // this.get_provinces()
    },
    methods: {
      get_request_address (item) {
        var address = ''
        if (item.CityName != null) {
          address += item.CityName + ' ,'
        }
        if (item.AreaName != null) {
          address += item.AreaName + ' ,'
        }
        if (item.AddressText != null) {
          address += item.AddressText + ' '
        }

        return address
      },
      go_direction (item) {
        var url = 'geo:0,0?q=' + item.Lat + ',' + item.Lng
        window.open(url, '_blank')
      },
      get_request_info () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          IsFinalize: 0,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/UserReqDash', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.request_info = response.data.recordInfo
              self.get_device_status()
              self.$route.meta.name = self.$t('showPreRequest') + self.request_info.RequestCode
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_request_full_info () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          IsFinalize: 0,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetPreReqRecInfo', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // self.request_info = response.data.recordInfo;
              // self.get_device_status();
              var PassingData = { on_site_service: true }
              PassingData.ServiceOutBranch = response.data.recordInfo.ServiceOutBranch
              PassingData.ServiceOutBranchOnFinalize = '0'
              PassingData.PreRequestId = response.data.recordInfo.Id
              PassingData.on_site_service = true
              PassingData.cat_id = response.data.recordInfo.ProductTypeId
              PassingData.group_id = response.data.recordInfo.CategoryId
              PassingData.sub_group_id = response.data.recordInfo.GroupId
              PassingData.brand_id = response.data.recordInfo.SubGroupId
              PassingData.customer_summary = response.data.recordInfo.Description
              PassingData.model_id = response.data.recordInfo.ModelId
              PassingData.model_title = response.data.recordInfo.ModelTitle
              PassingData.other_phone_code = response.data.recordInfo.OtherPhoneCode
              PassingData.other_phone_no = response.data.recordInfo.OtherPhoneNO
              PassingData.customer_mobile = response.data.recordInfo.PhoneNO
              PassingData.customer_name = ''
              PassingData.stateId = 'final_pre_request'
              // data.put("typeId", String.valueOf(model.getRec().getProductTypeId()));
              // data.put("parentTitle", "درخواست");
              // data.put("stateId", "editrequest");
              // data.put("customer_name", "");
              // data.put("delivery_status", "true");
              PassingData.request_name = self.$t('repair')

              localStorage.setItem('request_data', JSON.stringify(PassingData))
              console.log(PassingData)
              if (PassingData.ServiceOutBranch == true) {
                self.dialog_service_out_branch = true
              } else {
                self.$router.push({ name: 'groups', params: {} })
              }
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      service_out_branch_action (type) {
// console.log(type,this.request_statuses);
        var data = JSON.parse(localStorage.getItem('request_data'))
        data.ServiceOutBranchOnFinalize = this.request_statuses[type]
        localStorage.setItem('request_data', JSON.stringify(data))

        this.$router.push({ name: 'groups', params: {} })
      },
      go_to_categories () {
        var has_exist = false
        var self = this
        // console.log("statuses is "+JSON.stringify(this.request_statuses));
        var has_exist = false
        self.request_statuses.forEach(function (number) {
          if (self.request_info.StatusId == number) {
            has_exist = true
          }
        })
        if (!has_exist) {
          self.action_button_text = 'شروع به حرکت'
          self.next_action_status = self.request_statuses[0]
        }

        if (self.request_info.StatusId == self.request_statuses[0]) {
          self.action_button_text = self.$t('submit_receive')
          self.next_action_status = self.request_statuses[1]
        }

        if (self.request_info.StatusId == self.request_statuses[1]) {
          self.action_button_text = self.$t('finalize_request')
          self.next_action_status = self.request_statuses[1]
          self.get_request_full_info()
          return false
        }

        this.change_request_status(this.next_action_status)
      },
      get_device_status () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetStatusSetting', send_data, {})
          .then(response => {
            self.request_statuses = response.data.rslt
            var has_exist = false
            self.request_statuses.forEach(function (number) {
              if (self.request_info.StatusId == number) {
                has_exist = true
              }
            })
            if (!has_exist) {
              self.action_button_text = self.$t('start_driving')
              self.next_action_status = self.request_statuses[0]
            } else if (self.request_info.StatusId == self.request_statuses[0]) {
              self.action_button_text = this.$t('submit_receive')
              self.next_action_status = self.request_statuses[1]
            } else if (self.request_info.StatusId == self.request_statuses[1]) {
              self.action_button_text = this.$t('finalize_request')
              self.next_action_status = self.request_statuses[1]
            } else {
              self.action_button_text = ''
              self.next_action_status = 0
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      change_request_status (status_id) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          Desc: '',
          StatusId: status_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ChangePreRequestStatus', send_data, {})
          .then(response => {
            self.get_request_info()
          }).catch(e => {
          this.errors.push(e)
        })
      },

    }
  }
</script>
